module.exports = __webpack_public_path__ + "static/assets/58f20bb3e3aa666fb36a27ba5a0f746f.png";